exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-full{min-width:200px}.brdr-radius-20{border-radius:20px}\n", ""]);

// exports
